module.exports = __webpack_public_path__ + "media/images/icons/password-9f5ac4acd68055ee93ad4138b222aece.svg";